import { BaseSpine } from '../pixi/pixiBaseSpine';

const commonMethods = {
  hide() {
    this.visible = false;
  },
  show() {
    this.visible = true;
  },
  setScale(values) {
    if (typeof values === 'number') this.scale.set(values);
    else if (typeof values === 'object') {
      this.scale.set(values.x, values.y);
    }
  },
  destroy(...args) {
    this.constructor.prototype.destroy.call(this, ...args); // super y stex chi ashxatum dra hamar ays dzevov areci
    this.__listeners.forEach((u) => u());
    this.__listeners.length = 0;
  },
};

export function construct(options) {
  if (options?.parent) {
    if (options.slotName && options.parent instanceof BaseSpine) {
      options.parent.addChildToSlot(options.slotName, this);
    } else options.parent.addChild(this);
  }
  this.elementId = options.elementId;
  Object.keys(commonMethods).forEach((method) => {
    this[method] = commonMethods[method].bind(this);
  });
  if (options.styles) this.applyStyles(options.styles);
  if (options.setRef) options.setRef(this);
  if (options.children) {
    options.children.forEach((ch) => ch && this.addChild(ch));
  }
  this.__listeners = [];
}

// const commonSetterGetters = {
//     enabled:{
//         setDefault(){
//             this._enabled = false;
//         },
//         setter(v){
//             if(!this.interactive || this._enabled === v)return;
//             this._enabled = v;
//             this.buttonMode = v;
//             this.emit(v ? 'enabled' : 'disabled');
//         },
//         getter(){
//             return this.interactive && this._enabled;
//         }
//     }
// };
const MOUSE_LEFT_BUTTON = 0;
export function isValidMouseButtonInput(event) {
  return event.data.pointerType !== 'mouse' || event.data.button === MOUSE_LEFT_BUTTON;
}
